/**
 * Blog article commerce (sections/main-article2.liquid): add-to-cart from the
 * inline card, routine rows and the sticky bar without leaving the page, the
 * mobile sticky bar, and one DOM event per interaction for analytics
 * (snippets/amplitude-events.liquid listens). ES5 on purpose: no build step.
 *
 * Cart: POST /cart/add.js. With Rebuy Smart Cart enabled (body.smart-cart--enabled)
 * Rebuy opens itself; otherwise the theme's quick cart is refreshed and opened
 * through its registered section instance (window.Shopify.theme.sections.instances).
 */
(function () {
  var root = document.querySelector('[data-article-commerce]');
  var articleHandle = root ? root.getAttribute('data-article-handle') : '';
  var articleMode = root ? root.getAttribute('data-article-mode') : '';

  function quickCart() {
    try {
      var list = (window.Shopify && Shopify.theme && Shopify.theme.sections && Shopify.theme.sections.instances) || [];
      for (var i = 0; i < list.length; i++) {
        if (list[i] && list[i].type === 'quick-cart') return list[i];
      }
    } catch (e) {}
    return null;
  }

  function rebuyCart() {
    try {
      if (document.body.classList.contains('smart-cart--enabled') && window.Rebuy && Rebuy.SmartCart) return Rebuy.SmartCart;
    } catch (e) {}
    return null;
  }

  function openCart() {
    // Rebuy Smart Cart hooks /cart/add itself and opens on its own; opening the
    // theme's quick cart as well leaves a second drawer under it. Only refresh
    // the theme's cart count, and nudge Rebuy open if it did not react.
    var rb = rebuyCart();
    try { document.dispatchEvent(new CustomEvent('apps:product-added-to-cart')); } catch (e) {}
    if (rb) {
      setTimeout(function () {
        try { if (!rb.visible && typeof rb.show === 'function') rb.show(); } catch (e) {}
      }, 400);
      return;
    }
    var qc = quickCart();
    if (qc && typeof qc.openQuickCart === 'function') {
      try { if (typeof qc.refreshQuickCart === 'function') qc.refreshQuickCart(); } catch (e) {}
      // The refresh fetches the cart section; give it a beat before opening.
      setTimeout(function () { try { qc.openQuickCart(); } catch (e) {} }, 350);
      return;
    }
    window.location.href = (window.theme && theme.routes && theme.routes.cart && theme.routes.cart.base) || '/cart';
  }

  // ---- Analytics: one DOM event per interaction.
  function emit(detail) {
    detail.article_handle = articleHandle;
    if (!detail.mode) detail.mode = articleMode;
    window.__articleModule = { module: detail.module, mode: detail.mode };
    try { document.dispatchEvent(new CustomEvent('article:module', { detail: detail })); } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      var row = { event: 'blog_module' };
      for (var k in detail) if (Object.prototype.hasOwnProperty.call(detail, k)) row[k] = detail[k];
      window.dataLayer.push(row);
    } catch (e) {}
  }

  function moduleOf(el) {
    var m = el.closest('[data-module]');
    return {
      module: m ? m.getAttribute('data-module') : '',
      mode: m ? m.getAttribute('data-mode') : '',
      product_id: m ? m.getAttribute('data-product-id') || undefined : undefined
    };
  }

  // ---- Add to cart
  function addUrl() {
    var r = (window.theme && theme.routes && theme.routes.cart && theme.routes.cart.add) || '/cart/add';
    return r.replace(/\.js$/, '') + '.js';
  }

  function variantIdsFor(btn) {
    var multi = btn.getAttribute('data-variant-ids');
    if (multi) return multi.split(',').filter(Boolean);
    var card = btn.closest('.article-card');
    var select = card ? card.querySelector('.article-card__variants') : null;
    if (!select && btn.getAttribute('data-card-target')) {
      var target = document.querySelector(btn.getAttribute('data-card-target'));
      select = target ? target.querySelector('.article-card__variants') : null;
    }
    var id = select ? select.value : btn.getAttribute('data-variant-id');
    return id ? [id] : [];
  }

  function showError(btn, message) {
    var host = btn.closest('.article-card, .article-routine, .article-routine-table, .article-sticky');
    var line = host ? host.querySelector('.article-card__error') : null;
    if (!line) return;
    line.textContent = message || '';
    line.hidden = !message;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-article-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || btn.classList.contains('loading')) return;
    var ids = variantIdsFor(btn);
    if (!ids.length) return;
    var meta = moduleOf(btn);
    emit({ module: meta.module, action: 'add', mode: meta.mode, product_id: meta.product_id, variant_id: ids.join(',') });

    btn.classList.add('loading');
    btn.setAttribute('aria-disabled', 'true');
    showError(btn, '');

    fetch(addUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state && state.status) { showError(btn, state.description || state.message || ''); return; }
        openCart();
        try { document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: state.items ? state.items[0] : state } })); } catch (err) {}
      })
      .catch(function (err) { showError(btn, 'Could not add to cart. Please try again.'); if (window.console) console.error(err); })
      .then(function () {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
      });
  });

  // Soft-card, title and routine-row links: a click event, no add.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-article-link]');
    if (!link) return;
    var meta = moduleOf(link);
    emit({ module: meta.module, action: 'click', mode: meta.mode, product_id: meta.product_id });
  });

  // Variant select updates the card button and the sticky bar.
  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('.article-card__variants');
    if (!select) return;
    var card = select.closest('.article-card');
    var btn = card ? card.querySelector('[data-article-add]') : null;
    if (btn) btn.setAttribute('data-variant-id', select.value);
    var opt = select.options[select.selectedIndex];
    var sticky = document.querySelector('article-sticky-bar');
    if (sticky && opt) {
      var price = sticky.querySelector('[data-sticky-price]');
      if (price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
      var buy = sticky.querySelector('[data-article-add]');
      if (buy) buy.setAttribute('data-variant-id', select.value);
    }
  });

  // ---- Sticky bar: visible once the watched card has scrolled above the viewport,
  // hidden while the footer is in view, a text field has focus, or the scroll
  // offer bar is showing (they would stack). Timer-throttled scroll handler so it
  // behaves the same in the theme editor preview.
  if (window.customElements && !customElements.get('article-sticky-bar')) {
    customElements.define('article-sticky-bar', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.card = document.querySelector(this.getAttribute('data-watch') || '.article-card--solid');
        this.footer = document.querySelector('footer, .footer, #footer');
        this.typing = false;
        this.shown = false;
        this.timer = null;
        if (!this.card) return;
        var onScroll = function () {
          if (self.timer) return;
          self.timer = setTimeout(function () { self.timer = null; self.update(); }, 80);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        document.addEventListener('focusin', function (e) {
          if (e.target.matches && e.target.matches('input, textarea, select')) { self.typing = true; self.update(); }
        });
        document.addEventListener('focusout', function () { self.typing = false; self.update(); });
        this.update();
      }
      update() {
        if (!this.card) return;
        var cardPassed = this.card.getBoundingClientRect().bottom < 0;
        var footerVisible = this.footer ? this.footer.getBoundingClientRect().top < window.innerHeight : false;
        var offerShowing = document.body.classList.contains('ma2-offer-visible');
        var visible = cardPassed && !footerVisible && !this.typing && !offerShowing;
        this.classList.toggle('is-visible', visible);
        document.body.classList.toggle('article-sticky--visible', visible);
        if (visible && !this.shown) {
          this.shown = true;
          emit({ module: 'sticky_bar', action: 'view', product_id: this.getAttribute('data-product-id') || undefined });
        }
      }
    });
  }

  // ---- Cards and routine modules: a view event when they enter the viewport.
  if ('IntersectionObserver' in window) {
    var viewed = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio <= 0) return;
        var el = entry.target;
        emit({ module: el.getAttribute('data-module'), action: 'view', mode: el.getAttribute('data-mode'), product_id: el.getAttribute('data-product-id') || undefined });
        obs.unobserve(el);
      });
    }, { threshold: 0.25 });
    Array.prototype.forEach.call(document.querySelectorAll('[data-module][data-track-view]'), function (el) { viewed.observe(el); });
  }
})();
